import React, { useState } from 'react';
import { Zap } from 'lucide-react';
import { aiAPI } from '../../../services/api';

export const CheckinButton: React.FC = () => {
  const [isRunning, setIsRunning] = useState(false);
  const [result, setResult] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleTrigger = async () => {
    setIsRunning(true);
    setError(null);
    setResult(null);
    try {
      const res = await aiAPI.triggerSession();
      setResult(res.message);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to trigger session');
    } finally {
      setIsRunning(false);
    }
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-1.5 mb-1">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Run Agent Session
        </label>
        <button
          type="button"
          onClick={handleTrigger}
          disabled={isRunning}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-blue-900/20 dark:border-blue-800 dark:text-blue-400 dark:hover:bg-blue-900/30 transition-colors"
        >
          <Zap className={`w-3.5 h-3.5 ${isRunning ? 'animate-pulse' : ''}`} />
          {isRunning ? 'Starting...' : 'Run Now'}
        </button>
      </div>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">
        Manually run an autonomous agent session. The agent will review your tasks, habits, and schedule, and may send you a Telegram message if it has something useful to share.
      </p>

      {error && (
        <div className="mb-2 p-2 bg-red-50 border border-red-200 rounded-md dark:bg-red-900/20 dark:border-red-800">
          <p className="text-xs text-red-600 dark:text-red-400">{error}</p>
        </div>
      )}

      {result && (
        <div className="p-2 rounded-md border text-sm bg-green-50 border-green-200 text-gray-700 dark:bg-green-900/20 dark:border-green-800 dark:text-gray-300">
          {result}
        </div>
      )}
    </div>
  );
};
